NS("GIS.Map.Layer.Leaflet");

GIS.Map.Layer.Leaflet.Base = Class(Events, {
    map: null,
    base: null,
    layer: null,

    initialize: function(map, base, options) {
        this.map = map;
        this.base = base;

        Util.merge(this, options);
    },

    destroy: function() {},

    visible: function() {
        return this.map.map.hasLayer(this.layer);
    },

    show: function() {
        if (!this.visible()) {
            this.map.map.addLayer(this.layer);
        }
    },

    hide: function() {
        if (this.visible()) {
            this.map.map.removeLayer(this.layer);
        }
    },

    setOpacity: function(opacity) {},

    getOpacity: function() {}
});
